import { useCallback } from 'react';
import type { JSX } from 'react';

import { Loader } from '@change-corgi/design-system/components/progressiveDisclosure';
import { Box } from '@change-corgi/design-system/layout';

import { LazyComponent } from 'src/app/shared/components/layout/lazy';

import type { AIDescriptionStep } from './AIDescription';

async function LoadAIDescriptionStep(): Promise<typeof AIDescriptionStep> {
	return (await import(/* webpackChunkName: "pages/start-a-petition-steps-ai-description" */ './AIDescription'))
		.AIDescriptionStep;
}

export function AIDescriptionLoader(): JSX.Element {
	const loadComponent = useCallback(LoadAIDescriptionStep, []);

	return (
		<LazyComponent
			loadComponent={loadComponent}
			fallback={
				<Box margin="auto">
					<Loader />
				</Box>
			}
		/>
	);
}

export const preloadAIDescriptionStep = LoadAIDescriptionStep;
